export default "__VITE_PUBLIC_ASSET__b252d682__"